<template>
  <div class="content-dash2">
    <!-- TOPO: 3 GRÁFICOS -->
    <div class="dash2-top">
      <div class="chart-box">
        <h3 class="chart-title">Alertas por Grupo</h3>
        <FrotaAlertasPorGrupoChart :data="chartGrupo" />
      </div>

      <div class="chart-box">
        <h3 class="chart-title">Top Serviços em Alerta</h3>
        <FrotaAlertasPorServicoChart :data="chartServico" />
      </div>

      <div class="chart-box">
        <h3 class="chart-title">Despesas por Grupo (30 Dias)</h3>
        <FrotaDespesasPorGrupoPieChart :data="chartDespesasGrupo" />
      </div>
    </div>

    <!-- BASE: ESQUERDA (CARDS + FILTROS) | DIREITA (TABELA) -->
    <div class="dash2-bottom">
      <div class="dash2-left">
        <!-- CARDS -->
        <div class="card-dash">
          <div class="row">
            <h3>Alertas Ativos</h3>
            <h2>{{ Funcoes.formatInteger(kpis.alertas) }}</h2>
          </div>
          <h2 class="sub">Serviços em alerta</h2>
        </div>

        <div class="card-dash">
          <div class="row">
            <h3>Equipamentos em Alerta</h3>
            <h2>{{ Funcoes.formatInteger(kpis.equipamentos) }}</h2>
          </div>
          <h2 class="sub">Com pelo menos 1 alerta</h2>
        </div>

        <div class="card-dash">
          <div class="row">
            <h3>Serviços Afetados</h3>
            <h2>{{ Funcoes.formatInteger(kpis.servicos) }}</h2>
          </div>
          <h2 class="sub">Tipos de serviços</h2>
        </div>

        <div class="card-dash">
          <div class="row">
            <h3>Grupos Afetados</h3>
            <h2>{{ Funcoes.formatInteger(kpis.grupos) }}</h2>
          </div>
          <h2 class="sub">Categorias de equipamento</h2>
        </div>
      </div>

      <!-- TABELA -->
      <div class="dash2-right">
        <div class="content-dash-table">
          <div class="row table-head">
            <h3>Equipamentos com mais alertas</h3>
            <div class="muted">
              {{ Funcoes.formatInteger(topEquipamentos.length) }} registros
            </div>
          </div>

          <table class="tbl">
            <thead>
              <tr>
                <th>Equipamento</th>
                <th>Grupo</th>
                <th class="col-center">Alertas</th>
                <th class="col-center">Mais crítico</th>
                <!-- <th class="col-center">Ação</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in topEquipamentos" :key="row.idequipamento" class="row-clickable">
                <td>
                  <div class="td-title">
                    {{ row.cdequipamento }} - {{ row.nmequipamento }}
                  </div>
                  <div class="td-sub">
                    Placa: {{ row.placa || '-' }}
                  </div>
                </td>

                <td>{{ row.nmgrupo || row.idgrupo }}</td>

                <td class="col-center">
                  <span class="badge badge-alert">{{ Funcoes.formatInteger(row.qtd) }}</span>
                </td>

                <td class="col-center">
                  <span :class="['badge', row.criticoStatus === 'VENCIDO' ? 'badge-vencido' : 'badge-alert']">
                    {{ row.criticoLabel }}
                  </span>
                </td>

                <!-- <td class="col-center">
                  <button class="btn-open" @click.stop="abrirEquipamento(row.idequipamento)">Abrir</button>
                </td> -->
              </tr>

              <tr v-if="!topEquipamentos.length && !loading">
                <td colspan="5" class="empty">
                  Nenhum dado encontrado para os filtros informados.
                </td>
              </tr>

              <tr v-if="loading">
                <td colspan="5" class="empty">Carregando...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { genericPost } from '@/funcoes/api';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';

import FrotaAlertasPorGrupoChart from '@/components/charts/FrotaAlertasPorGrupoChart.vue';
import FrotaAlertasPorServicoChart from '@/components/charts/FrotaAlertasPorServicoChart.vue';
import FrotaDespesasPorGrupoPieChart from '@/components/charts/FrotaDespesasPorGrupoPieChart.vue';

const loading = ref(false);
const dados = ref([]);

const filtros = ref({
  idmunicipio: globalStore.idmunicipio,
  idequipamento: 0,
  idequipamentogrupo: 0,
  idequipamentosetor: 0,
  ativo: 'S',
});

const kpis = ref({
  alertas: 0,
  equipamentos: 0,
  servicos: 0,
  grupos: 0,
});

const chartGrupo = ref([]);          // [{ x:'VEÍCULOS PESADOS', y: 10 }, ...]
const chartServico = ref([]);        // [{ x:'TROCA...', y: 5 }, ...]
const chartDespesasGrupo = ref([]);  // [{ label:'COMBUSTIVEL', value:4557 }, ...]
const topEquipamentos = ref([]);     // [{ idequipamento, qtd, criticoLabel, ... }]

const uniqCount = (arr) => new Set(arr.filter(v => v !== null && v !== undefined)).size;

const pad2 = (n) => String(n).padStart(2, '0');
const formatDateBr = (dt) => `${pad2(dt.getDate())}/${pad2(dt.getMonth() + 1)}/${dt.getFullYear()}`;

const getPeriodoMesAtual = () => {
  // 01-02-2026: FIZ AJUSTE PARA PEGAR ULTIMOS 30 DIAS
  const hoje = new Date();
  // const ini = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
  // const fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
  const ini = new Date(hoje.getFullYear(), hoje.getMonth() - 1, hoje.getDay());
  const fim = hoje;//new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDay());
  return { datainicial: formatDateBr(ini), datafinal: formatDateBr(fim) };
};

const calcularCriticidade = (item) => {
  const hoje = new Date();
  const kmAtual = item.kmatual ?? null;
  const kmProx = item.kmproxima ?? null;
  const dtProx = item.dtproxima ?? null;

  if (dtProx) {
    const dt = new Date(dtProx + 'T00:00:00');
    const dias = Math.floor((dt - hoje) / (1000 * 60 * 60 * 24));
    const status = dias < 0 ? 'VENCIDO' : 'ALERTA';
    return {
      status,
      label: dias < 0 ? `${Math.abs(dias)}d vencido` : `${dias}d p/ vencer`,
      score: dias,
    };
  }

  if (kmAtual !== null && kmProx !== null && kmProx > 0) {
    const resto = kmProx - kmAtual;
    const status = resto < 0 ? 'VENCIDO' : 'ALERTA';
    return {
      status,
      label: resto < 0 ? `${Math.abs(resto)} vencido` : `${resto} restantes`,
      score: resto,
    };
  }

  return { status: 'ALERTA', label: 'sem previsão', score: 999999 };
};

const montarDashboard = (ls) => {
  const alertas = ls.filter(x => (x.ckalerta || 'N') === 'S');

  kpis.value = {
    alertas: alertas.length,
    equipamentos: uniqCount(alertas.map(x => x.idequipamento)),
    servicos: uniqCount(alertas.map(x => x.idservico)),
    grupos: uniqCount(alertas.map(x => x.idgrupo)),
  };

  // Alertas por Grupo
  const mapGrupo = new Map();
  alertas.forEach(x => {
    const nome = x.nmgrupo || String(x.idgrupo);
    const obj = mapGrupo.get(nome) || { x: nome, y: 0 };
    obj.y += 1;
    mapGrupo.set(nome, obj);
  });
  chartGrupo.value = Array.from(mapGrupo.values()).sort((a, b) => b.y - a.y);

  // Alertas por Serviço (Top 10)
  const mapServico = new Map();
  alertas.forEach(x => {
    const key = x.idservico;
    const nome = x.nmservico || String(key);
    const obj = mapServico.get(key) || { x: nome, y: 0 };
    obj.y += 1;
    mapServico.set(key, obj);
  });
  chartServico.value = Array.from(mapServico.values())
    .sort((a, b) => b.y - a.y)
    .slice(0, 10);

  // Top equipamentos com mais alertas
  const mapEquip = new Map();
  alertas.forEach(x => {
    const key = x.idequipamento;
    const row = mapEquip.get(key) || {
      idequipamento: x.idequipamento,
      cdequipamento: x.cdequipamento,
      nmequipamento: x.nmequipamento,
      placa: x.placa,
      idgrupo: x.idgrupo,
      nmgrupo: x.nmgrupo || null,
      qtd: 0,
      criticoScore: 999999,
      criticoLabel: 'sem previsão',
      criticoStatus: 'ALERTA',
    };

    row.qtd += 1;

    const c = calcularCriticidade(x);
    if (c.score < row.criticoScore) {
      row.criticoScore = c.score;
      row.criticoLabel = c.label;
      row.criticoStatus = c.status;
    }

    mapEquip.set(key, row);
  });

  topEquipamentos.value = Array.from(mapEquip.values())
    .sort((a, b) => {
      if (a.criticoScore !== b.criticoScore) return a.criticoScore - b.criticoScore;
      return b.qtd - a.qtd;
    })
    .slice(0, 10);
};

const loadAll = async () => {
  loading.value = true;
  try {
    const { datainicial, datafinal } = getPeriodoMesAtual();

    const [respStatus, respDespesas] = await Promise.all([
      genericPost('/dados/frota/manutencao/status', {
        idmunicipio: filtros.value.idmunicipio,
        idequipamento: filtros.value.idequipamento,
        idequipamentogrupo: filtros.value.idequipamentogrupo,
        idequipamentosetor: filtros.value.idequipamentosetor,
        ativo: filtros.value.ativo,
      }),
      genericPost('/dashboard/frota/despesas/grupo', {
        idmunicipio: filtros.value.idmunicipio,
        datainicial,
        datafinal,
      }),
    ]);

    dados.value = respStatus || [];
    montarDashboard(dados.value);

    const lsDesp = respDespesas || [];
    chartDespesasGrupo.value = lsDesp
      .map(x => ({
        label: x.nmdespesagrupo,
        value: Number(x.vldespesas || 0),
      }))
      .filter(x => x.value > 0);

  } catch (e) {
    console.error('Erro ao carregar dashboard frota:', e);
    dados.value = [];
    montarDashboard([]);
    chartDespesasGrupo.value = [];
  } finally {
    loading.value = false;
  }
};

// const abrirEquipamento = (idequipamento) => {
//   console.log('Abrir equipamento:', idequipamento);
// };

onMounted(() => {
  loadAll();
});
</script>

<style scoped>
/* Layout geral */
.content-dash2{
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

/* TOPO: 3 gráficos */
.dash2-top{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
}

/* BASE: esquerda (cards+filtros) / direita (tabela) */
.dash2-bottom{
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 12px;
  align-items: start;
}

.dash2-left{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dash2-right{
  min-width: 650px;
}

/* Mantém teu estilo original */
.card-dash{
  background-color: #ebf2f2;
  padding: 6px;
  border-radius: 8px;
  border: 2px solid #3c5d5d;
  text-align: end;
}

.sub{
  font-size: 14px;
  color: #3c5d5d;
  font-weight: bold;
}

.chart-box{
  border: 2px solid #3c5d5d;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
  min-height: 280px;
}

.chart-title{
  margin: 0 0 6px 0;
  color: #3c5d5d;
}

.content-dash-table{
  border: 2px solid #3c5d5d;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

.table-head{
  justify-content: space-between;
  align-items: baseline;
}

.tbl{
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}

.tbl th{
  text-align: left;
  border-bottom: 2px solid #3c5d5d;
  padding: 8px 6px;
  color: #3c5d5d;
}

.tbl td{
  border-bottom: 1px solid #dde7e7;
  padding: 8px 6px;
  vertical-align: top;
}

.col-center{
  text-align: center;
}

.row{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}

.row-space{
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
}

.lbl{
  color: #3c5d5d;
  font-weight: bold;
  font-size: 13px;
}

.inp{
  padding: 6px;
  border: 1px solid #3c5d5d;
  border-radius: 6px;
}

.filters-box{
  border: 2px dashed #3c5d5d;
  border-radius: 8px;
  padding: 8px;
  background: #f6fbfb;
}

.btn-refresh{
  border: 2px solid #3c5d5d;
  border-radius: 6px;
  background: #ebf2f2;
  padding: 4px 10px;
  cursor: pointer;
  font-weight: bold;
}

.td-title{
  font-weight: bold;
}

.td-sub{
  font-size: 12px;
  color: #657979;
}

.muted{
  font-size: 12px;
  color: #657979;
}

.empty{
  text-align: center;
  padding: 14px;
  color: #657979;
}

.row-clickable{
  cursor: pointer;
}

.badge{
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: bold;
  border: 1px solid #3c5d5d;
  background: #ebf2f2;
}

.badge-alert{
  background: #fff2cc;
  border-color: #a67c00;
}

.badge-vencido{
  background: #ffd6d6;
  border-color: #a30000;
}

.btn-open{
  border: 1px solid #3c5d5d;
  border-radius: 6px;
  background: #ebf2f2;
  padding: 4px 10px;
  cursor: pointer;
}

.content-dash-hint{
  padding: 6px 10px;
}

/* Responsivo básico */
@media (max-width: 1200px){
  .dash2-top{
    grid-template-columns: 1fr;
  }
  .dash2-bottom{
    grid-template-columns: 1fr;
  }
  .dash2-right{
    min-width: unset;
  }
}
</style>
